// 模板 8：物流与仓储管理平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '一体化物流协同平台',
        content:
          '打通仓储、干线与末端配送流程，让每一票货物都有迹可循。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '运输可视化调度',
        content:
          '实时掌握车辆位置与在途订单，提升调度效率与客户体验。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '物流运营数据驾驶舱',
      subtitle: '/ Logistics Data Cockpit',
      paragraphs: [
        '围绕时效、成本与服务质量三大核心维度构建数据看板，帮助管理者快速定位问题环节。',
        '支持按线路、司机与客户等维度拆解指标，为精细化运营提供依据。'
      ],
      buttonText: '预约物流方案'
    },
    contact: {
      title: '物流企业数字化运营伙伴',
      subTitle: '让每一次运输决策更有数据支撑',
      buttonText: '获取咨询'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '联运智慧物流科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注公路与仓储物流的信息化建设，从 TMS、WMS 到可视化在途跟踪提供一站式平台。',
      '团队熟悉干线运输与城配业务场景，能够快速理解企业运营痛点。'
    ]
  },
  news: [
    {
      id: 'L01',
      title: '干线运输调度平台在多省落地',
      introduce:
        '平台帮助客户提升车辆周转效率，降低空驶率与管理成本。',
      date: '03-11',
      year: '2024'
    },
    {
      id: 'L02',
      title: '推出冷链运输温控监测模块',
      introduce:
        '支持多点温度采集与轨迹回放，保障冷链运输合规可靠。',
      date: '10-07',
      year: '2023'
    },
    {
      id: 'L03',
      title: '仓储作业效率提升专项项目验收通过',
      introduce:
        '通过作业流程优化与系统改造，帮助客户显著缩短出入库耗时。',
      date: '06-19',
      year: '2023'
    },
    {
      id: 'L04',
      title: '与多家车联网厂商达成合作',
      introduce:
        '加强在车辆数据采集与安全监控方面的能力整合。',
      date: '12-01',
      year: '2022'
    },
    {
      id: 'L05',
      title: '上线司机移动端作业助手',
      introduce:
        '司机可通过手机完成签到、回单上传与异常上报，提升整体协同效率。',
      date: '08-15',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '运输管理系统 TMS',
      sections: [
        {
          heading: '1. 订单与路线管理',
          content:
            '集中管理客户订单与运输线路，支持自动匹配最优路线。'
        },
        {
          heading: '2. 车辆与司机排班',
          content:
            '可视化呈现车辆与司机排班情况，避免冲突与闲置。'
        },
        {
          heading: '3. 费用结算',
          content:
            '支持运费、油费与过路费等多项费用记录与对账。'
        },
        {
          heading: '4. 客户服务',
          content:
            '向客户提供在途查询与签收状态反馈，提升服务体验。'
        }
      ]
    },
    bigData: {
      title: '物流数据分析平台',
      sections: [
        {
          heading: '1. 时效分析',
          desc:
            '统计不同线路与客户的准点率，识别影响时效的关键因素。'
        },
        {
          heading: '2. 车辆利用率',
          desc:
            '分析车队整体与单车利用情况，优化车辆配置。'
        },
        {
          heading: '3. 费用构成',
          desc:
            '拆解运输与仓储费用构成，为成本控制提供支撑。'
        },
        {
          heading: '4. 异常事件统计',
          desc:
            '记录并分析事故、延误与投诉等事件，为运营改善提供方向。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '物流数字化诊断',
      engTitle: 'Logistics Consulting',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: 'TMS/WMS 系统实施',
      engTitle: 'System Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '车队管理优化',
      engTitle: 'Fleet Optimization',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '运营数据顾问',
      engTitle: 'Operations Analytics',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '物流产品实施顾问',
    responsibilities: [
      '参与物流企业项目实施，负责需求调研与方案配置；',
      '在仓库与车队现场辅导用户使用系统；',
      '整理项目经验，形成标准化交付模板。'
    ],
    requirements: [
      '了解物流或仓储业务流程，有相关项目经验者优先；',
      '适应一定频次出差，具备良好的沟通与服务意识；',
      '动手能力强，愿意深入一线场景。'
    ],
    buttonText: '投递简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-8.js